import { TabPane } from 'semantic-ui-react'
import styled from 'styled-components'

export const Co2SettingsWrapper = styled.div`
display: flex;
flex-direction: column;
gap: 20px;
margin: 20px;
`
export const StyledTabPane = styled(TabPane)`
border: none !important;
`